import { pushToDataLayer } from '@almbrand/trackinghooks';
import { getBrandFromTheme } from 'common/trackingUtils';
import { useEffect } from 'react';
import { useThemeName } from './useThemeName';

/**
 * Custom hook to track page views and time spent on the page.
 *
 * This hook pushes data to the data layer for tracking purposes. It tracks the page section,
 * brand, previous page URL, platform, and full URL. It also tracks page view events and
 * timestamps for time spent on the page.
 *
 * Usage:
 *
 * ```tsx
 * useTrackPage();
 * ```
 */
export const useTrackPage = (company?: string) => {
	const themeName = useThemeName();
	const brand = getBrandFromTheme(themeName);

	useEffect(() => {
		// Only track if companyName is provided
		if (!company) {
			return;
		}

		// Push initial page data to the data layer
		pushToDataLayer({
			userData: {
				company: company,
				loginStatus: true,
				customerType: 'business',
			},
			pageSection: window.location.pathname,
			brand: brand,
			previousPageUrl: sessionStorage.getItem('previousPageUrl') || '',
			platform: 'web',
			fullUrl: window.location.href,
		});

		// Track pageview event
		pushToDataLayer({
			event: 'trackPageview',
		});

		// Update sessionStorage with the current page URL
		sessionStorage.setItem('previousPageUrl', window.location.href);
	}, [brand, company]);
};
